import { useState } from "react";
import { API_BASE_URL } from "../../../config/apiConfig";
import axios from "axios";
import "./SSOButton.css";

export const SSOButton = () => {
  const [loading, setLoading] = useState(false);
  const [ssoEnabled, setSsoEnabled] = useState(null);

  // Verifica se SSO è abilitato al mount
  useState(() => {
    const checkSSOStatus = async () => {
      try {
        const response = await axios.get(`${API_BASE_URL}/oauth/sso/status`);
        setSsoEnabled(response.data.sso_enabled);
      } catch (error) {
        console.warn("SSO non disponibile:", error);
        setSsoEnabled(false);
      }
    };
    
    checkSSOStatus();
  }, []);

  const handleSSOLogin = async () => {
    setLoading(true);

    try {
      // Step 1: Richiedi URL di autorizzazione Microsoft
      const response = await axios.post(`${API_BASE_URL}/oauth/sso/init`, {
        // redirect_uri opzionale, usa default da backend
      });

      const { auth_url, state } = response.data;

      // Salva state per validazione callback
      sessionStorage.setItem("sso_state", state);

      console.log("✅ Reindirizzamento a Microsoft Entra ID...");

      // Step 2: Redirect a Microsoft
      window.location.href = auth_url;
    } catch (error) {
      console.error("❌ Errore SSO init:", error);
      alert("Errore durante l'avvio del login SSO. Riprova.");
      setLoading(false);
    }
  };

  // Non mostrare pulsante se SSO non è abilitato
  if (ssoEnabled === false) {
    return null;
  }

  return (
    <button
      type="button"
      className="sso-button"
      onClick={handleSSOLogin}
      disabled={loading || ssoEnabled === null}
    >
      {loading ? (
        <span>Reindirizzamento...</span>
      ) : (
        <>
          <img
            src={`${process.env.PUBLIC_URL}/microsoft-logo.svg`}
            alt="Microsoft"
            className="sso-button-icon"
          />
          <span>Accedi con Microsoft</span>
        </>
      )}
    </button>
  );
};